(() => {
  const notices = document.querySelectorAll('.article-sale-notice[data-sale-end]');
  if (!notices.length) return;
  notices.forEach((notice) => {
    const content = notice.closest('.article-template__content');
    const link = content?.querySelector('.article-template__line-register-image, a[href$="/pages/line-register"]:has(img)');
    const banner = link?.closest('figure, .article-template__line-register-image, p') || link;
    if (banner) {
      banner.after(notice);
      notice.dataset.positioned = 'true';
    }
  });
  const update = () => {
    const now = Date.now();
    notices.forEach((notice) => {
      const end = Date.parse(notice.dataset.saleEnd);
      notice.hidden = notice.dataset.positioned !== 'true' || !Number.isFinite(end) || now >= end;
    });
  };
  update();
  // Recheck open pages and restored/background tabs as well as new page loads.
  notices.forEach((notice) => {
    const remaining = Date.parse(notice.dataset.saleEnd) - Date.now();
    if (remaining > 0 && remaining <= 2147483647) setTimeout(update, remaining);
  });
  setInterval(update, 60000);
  document.addEventListener('visibilitychange', update);
  window.addEventListener('pageshow', update);
})();
